
import { Component, EventEmitter, Input, Output } from '@angular/core';
import {TitleStr} from './TitleStr.moudle';

@Component({
  selector: 'comm-pagePosition',
  templateUrl: './pagePosition.component.html'
})
export class PagePositionComponent {
  @Input() titleList:TitleStr[]=[];
  constructor() {

  }

}
